/**
 * Download the content at the given url;
 * @param {string} url The download target
 * @param {string} [name] The name of the file to download
 */
export default function downloadFile(url, name = true) {
  const downloadLink = document.createElement('A');
  downloadLink.download = name;
  downloadLink.href = url;
  downloadLink.click();
}
